import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'mb-pdp-publications-dialog',
  templateUrl: './pdp-publications-dialog.component.html',
})
export class PdpPublicationsDialogComponent {

  @Input() publications: { name: string; url: string } | undefined

  constructor (public activeModal: NgbActiveModal) {
  }
}
